import React, { Fragment, useState } from "react"
import ReactDOM from "react-dom"
import { Box, List, ListItem, Link } from "@material-ui/core"
import { makeStyles, withStyles } from "@material-ui/core/styles"
import ContainerStyle from "../GridContainer/GridContainer"
import Grid from "@material-ui/core/Grid"
import EventsList from "../Content/Events/EventsList"
import NewsList from "../Content/News/NewsList"
import Article from "../Content/Article"
const useStyles = makeStyles(theme => ({
  ullist: {
    padding: 0,
  },
  listItem: {
    padding: 0,
    width: "auto",
  },
  tabLinkClass: {
    paddingLeft: "2rem",
    paddingRight: "2rem",
  },
}))
const useStylesCont = makeStyles(theme => ContainerStyle)

const TabLink = [
  {
    tabText: "News",
    tabClass: "d-flex h-50p align-items-center nav-link",
    tabLink: "#news",
    id: 1,
  },
  {
    tabText: "Events",
    tabClass: "d-flex h-50p align-items-center nav-link",
    tabLink: "#events",
    id: 2,
  },
  {
    tabText: "Projects",
    tabClass: "d-flex h-50p align-items-center nav-link",
    tabLink: "#projects",
    id: 3,
  },
  {
    tabText: "Feed",
    tabClass: "d-flex h-50p align-items-center nav-link",
    tabLink: "#feed",
    id: 4,
  },
]
const TabLinkCont = [
  {
    tabTitle: "Feed",
    tabContent: <Article />,
    tabClass: "tab-pane",
    id: 4,
  },
  {
    tabTitle: "Projects",
    tabContent: "Projects Content",
    tabClass: "tab-pane",
    id: 3,
  },
  {
    tabTitle: "News",
    tabContent: <NewsList />,
    tabClass: "tab-pane",
    id: 1,
  },
  {
    tabTitle: "Events",
    tabContent: <EventsList />,
    tabClass: "tab-pane",
    id: 2,
  },
]

const UserProfileTabs = () => {
  const [activeTabLink, setActiveTabLink] = useState(1)
  const [activeTabCont, setActiveTabCont] = useState(1)

  const TabToggle = id => {
    setActiveTabLink(id)
    setActiveTabCont(id)
  }
  const classes = useStylesCont()
  const styles = useStyles()
  return (
    <Fragment>
      <Box component="div" className="bg-white shadow-bottom">
        <Grid container className={classes.container}>
          <Grid item xs={12}>
            <List className={styles.ullist + " " + "nav nav-tabs"}>
              {TabLink.map(tabMenu => (
                <ListItem
                  className={styles.listItem + " " + "nav-item"}
                  key={tabMenu.id}
                >
                  <Link
                    href={tabMenu.tabLink}
                    className={
                      styles.tabLinkClass +
                      " " +
                      tabMenu.tabClass +
                      (tabMenu.id === activeTabLink ? " active" : "")
                    }
                    onClick={() => TabToggle(tabMenu.id)}
                  >
                    {tabMenu.tabText}
                  </Link>
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
      </Box>
      <Box component="div" className="tab-content mt-sm-60 mt-30">
        {TabLinkCont.map(tabCont => (
          <Box
            component="div"
            key={tabCont.id}
            className={
              tabCont.tabClass +
              " " +
              (tabCont.id === activeTabCont ? " active" : "")
            }
          >
            <Grid container className={classes.container}>
              <Grid item xs={12}>
                <h1>{tabCont.tabTitle}</h1>
                {tabCont.tabContent}
              </Grid>
            </Grid>
          </Box>
        ))}
      </Box>
    </Fragment>
  )
}
export default UserProfileTabs
